import React, { Component } from "react";
import {
  getChildCategoryListRequest,
  updateCategoryStatusByCategoryIdRequest,
  deleteCategoryByCategoryIdRequest,
} from "store/actions";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import Switch from "react-switch";
import { makeCategorySelectField } from "store/Masters/Category/selector";
import { createStructuredSelector } from "reselect";
import CustomDataTable from "components/Application/CustomDataTable";
import { confirmBox } from "helpers/messageHelper";
import { primaryColor, secondaryColor } from "scss/variables.module.scss";
import CircularIconButton from "components/Buttons/CircularIconButton";

const columns = [
  {
    label: "Sequence",
    field: "categorySeq",
  },
  {
    label: "Image",
    field: "subCategoryImage",
  },
  {
    label: "Sub Category Name",
    field: "subCategoryName",
  },
  {
    label: "Category Name",
    field: "categoryName",
  },
  {
    label: "Status",
    field: "status",
    sort: "disabled",
  },
  {
    label: "Actions",
    field: "actions",
    sort: "disabled",
  },
];

class SubCategoryList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subCategoryRecords: [],
    };
  }

  componentDidMount() {
    //Retrieve category list
    this.props.getChildCategoryListRequest();
  }

  onStatusChange = (checked, e, id) => {
    this.props.updateCategoryStatusByCategoryIdRequest(id, checked);
  };

  buildSubCategoryDataTable = (records) => {
    this.setState({
      subCategoryRecords: records.map((subCategory) => {
        let imageView = (
          <img
            className="img-thumbnail"
            src={subCategory.categoryImageUrl}
            alt={subCategory.categoryName}
            width="150"
          />
        );

        let actions = (
          <div className="text-center">
            <CircularIconButton
              icon="far fa-edit fa-lg"
              onClick={this.viewSubCategory(subCategory)}
              tooltip={"Edit"}
            />

            <CircularIconButton
              icon="far fa-trash-alt fa-lg"
              onClick={this.deleteSubCategory(subCategory.categoryId)}
              tooltip={"Delete"}
            />
          </div>
        );

        let status = (
          <div className="d-flex">
            <Switch
              className="switch-sm"
              onColor={primaryColor}
              offColor={secondaryColor}
              onChange={(checked, e, id) => this.onStatusChange(checked, e, id)}
              id={subCategory.categoryId + ""}
              checked={subCategory.status ? true : false}
            />
            &nbsp;
          </div>
        );

        return {
          categorySeq: subCategory.categorySeq,
          categoryName: subCategory.parentName,
          subCategoryImage: imageView,
          subCategoryName: subCategory.categoryName,
          status: status,
          actions: actions,
        };
      }),
    });
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (this.props.categoryData !== nextprops.categoryData) {
      this.buildSubCategoryDataTable(nextprops.categoryData);
    }
  }

  viewSubCategory = (subCategoryData) => () => {
    this.props.onViewSubCategory(subCategoryData);
  };

  deleteSubCategory = (subCategoryId) => async () => {
    const response = await confirmBox();
    if (response) {
      this.props.deleteCategoryByCategoryIdRequest(subCategoryId);
    }
  };

  render() {
    const data = {
      columns: columns,
      rows: this.state.subCategoryRecords,
    };

    return (
      <React.Fragment>
        <CustomDataTable data={data} />
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  // JSON for the sub category list
  categoryData: makeCategorySelectField("categoryData"),
});

const withConnect = connect(mapStatetoProps, {
  getChildCategoryListRequest,
  updateCategoryStatusByCategoryIdRequest,
  deleteCategoryByCategoryIdRequest,
});

export default compose(withConnect, withRouter)(SubCategoryList);
